/**
 * 📝 LOGGER SYSTEM - Système de logging configurable
 * ==================================================
 * 
 * Remplace les console.log/error/warn par un système configurable
 * selon l'environnement (dev/production)
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugging = process.env.REACT_APP_DEBUG === 'true';

const logger = {
  /**
   * Log d'information (équivalent console.log)
   */
  info: (...args) => {
    if (isDevelopment || isDebugging) {
      console.log('ℹ️', ...args);
    }
  },

  /**
   * Log d'erreur (équivalent console.error)
   */
  error: (...args) => {
    // Les erreurs sont toujours affichées
    console.error('❌', ...args);
  },

  /**
   * Log d'avertissement (équivalent console.warn)
   */
  warn: (...args) => {
    if (isDevelopment || isDebugging) {
      console.warn('⚠️', ...args);
    }
  },

  /**
   * Log de succès
   */
  success: (...args) => {
    if (isDevelopment || isDebugging) {
      console.log('✅', ...args);
    }
  },

  /**
   * Log de debug (uniquement si REACT_APP_DEBUG=true)
   */
  debug: (...args) => {
    if (isDebugging) {
      console.log('🔧', ...args);
    }
  }
};

export default logger;